import React from 'react'
import RichTextEditor from '@/components/rich-text-editor'

export type TextEditorProps = {
	initialValue?: string
	onChange?: (html: string) => void
	placeholder?: string
}
export const TextEditor = ({
	initialValue = '',
	onChange,
	placeholder = '',
}: TextEditorProps) => {
	return (
		<RichTextEditor
			initialValue={initialValue}
			onChange={onChange}
			placeholder={placeholder}
			className="mb-4"
		/>
	)
}
